import ScrollMagic from "scrollmagic";
// ScrollMagic: https://scrollmagic.io/docs/ScrollMagic.Scene.html

// movieClip: https://pixijs.io/animate/classes/movieclip.html
export function runScrollMagic(view, movieClip, data) {
  const triggerFn = onValueChangeTrigger((frame) => {
    if (data._loop?.checkFrame(frame)) {
      if (data._loop.isLoop) {
        return;
      }
      // console.log("===== gotoAndPlay");
      movieClip.gotoAndPlay(frame);
      if (data._loop) {
        data._loop.isLoop = true;
      }
    } else {
      // console.log("gotoAndStop");
      movieClip.gotoAndStop(frame);
      if (data._loop) {
        data._loop.isLoop = false;
      }
    }
  });

  const controller = new ScrollMagic.Controller({
    refreshInterval: 200,
  });
  // console.log('document.body.contains(view);', document.body.contains(view), view)
  // get window height
  const wh = window.innerHeight;
  const offset = -(wh - data.height) / 2;
  new ScrollMagic.Scene({
    triggerElement: view, // starting scene, when reaching this element
    offset: offset, // start scene after scrolling for 100px
    duration: wh, // pin the element for 400px of scrolling
    // triggerHook: 0.8 // 值是一個介於 0 和 1 之間的數字，滾動視窗觸(瀏覽器位置)發場景的位置，1是開頭，0是結尾，0.5是中間
  })
    .on("progress", function (e) {
      // console.log(e)
      const frame = Math.floor(data.totalFrames * e.progress);
      triggerFn(frame);
    })
    // TODO: ScrollMagic debugger
    // .addIndicators()
    .addTo(controller);

  return controller;
}

function onValueChangeTrigger(cb) {
  let lastValue;
  return (value) => {
    if (value != lastValue) {
      cb(value);
      lastValue = value;
    }
  };
}


export function scrollController(element, inCallback, outCallback) {
  const options = {
    root: null,
    rootMargin: "0px",
    threshold: 0,
  };

  const observer = new IntersectionObserver((entries, owner) => {
    // console.log(owner); // IntersectionObserver 實體
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        // 目標元素進入 viewport 時執行
        inCallback && inCallback()
      } else {
        // 目標元素離開 viewport 時執行
        outCallback && outCallback()
      }
    });
  }, options);

  observer.observe(element);

  return {
    destroy: () => {
      observer.unobserve(element);
    },
  };
}
